// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_ListaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Chamados_ListaInput — GET /chamados/lista.
 *
 * `aba` é o filtro das duas abas da tela. Recusa qualquer outro valor em vez de
 * cair num default silencioso: uma aba desconhecida que devolvesse "tudo" faria
 * a tela mostrar chamado encerrado misturado com o que está em andamento, e
 * ninguém desconfiaria da lista — só acharia a tela confusa.
 *
 * `franquia_id` só é honrado para `Full` (o controller ignora para os demais).
 * Ele NÃO é o escopo de segurança de ninguém: para o franqueado o escopo é o
 * `sub` do JWT, e para o `Full` isto é conveniência de filtro.
 */
import { registerContract } from './validate'

export interface Chamados_ListaInput {
aba?: string
franquia_id?: number
agente?: string
}

registerContract('Chamados_ListaInput', {
  aba:         { type: 'string',  required: false },
  franquia_id: { type: 'number',  required: false },
  agente:      { type: 'string',  required: false },
})
